var s,o,BB = {

    settings: {
      menuOpen: false
    },

    objects: {
      sideMenu: document.querySelector('#sidemenu'),
      sideNavMenuCollapseItems: document.querySelector('.sidenav_mobile_main'),
      menuIcon: document.querySelector('#icon-menu'),
      siteHTML: document.querySelector('html'),
      siteBody: document.querySelector('body')
    },
    
    init: function() {
      s = BB.settings;
      o = BB.objects;      
      BB.menu();
    },

    menu: function() {
      
      if(!o.menuIcon) { return;}
      
      let sideClose = o.sideMenu.querySelector('#close'),
          underlay = o.sideMenu.querySelector('#underlay');

      BB.navMenuItemsAccordion(); // Run the mobile menu accordions
      
      o.menuIcon.addEventListener('click', (e) => {
        e.preventDefault();
        BB.menuToggle();
      })

      sideClose.addEventListener('click', (e) => {
        e.preventDefault();
        BB.menuToggle();
      });

      underlay.addEventListener('click', (e) => {
        console.log('click');
        e.preventDefault();
        BB.closeMenu();
      });
      
    },

    menuToggle: function() {
      if(s.menuOpen) { BB.closeMenu() } else { BB.openMenu() }
    },

    openMenu: function() {
      s.menuOpen = true;
      o.sideMenu.classList.add('active');
      o.menuIcon.classList.add('active');
      o.siteHTML.classList.add('menuopen');
    },

    closeMenu: function() {
      s.menuOpen = false;
      o.sideMenu.classList.remove('active');
      o.menuIcon.classList.remove('active');
      o.siteHTML.classList.remove('menuopen');
    },

    navMenuItemsAccordion: function() {
      
      let accordions = o.sideNavMenuCollapseItems.querySelectorAll('.accordionwrapper');
      
      accordions.forEach( (accor) => {
        let trigger = accor.querySelector('.collapse_trigger');
        let menu = accor.querySelector('.collapse');
        if(trigger && menu) {
          trigger.addEventListener('click', () => {
            if(menu.classList.contains('close')) {
              closeAllMobileAccordions();
              menu.classList.remove('close');
            } else {
              menu.classList.add('close');
            }
            
          })
        }
      });

      function closeAllMobileAccordions() {
        accordions.forEach( (accor) => {
          accor.querySelector('.collapse').classList.add('close');
        });
      }
      
    }
  
}


addEventListener("load", (event) => {
  BB.init();
});